<template>
    <v-menu offset-y left transition="slide-y-transition">
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" class="more-options-btn">
                <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
        </template>
        <v-list dense>
            <!-- Obsługa zdarzenia Section -->
            <!-- <v-subheader>Obsługa zdarzenia</v-subheader>
            <v-list-item v-if="canOpenTask" @click="$emit('start-dispatcher-task')">
                <v-list-item-icon>
                    <v-icon color="success">mdi-progress-star</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Rozpocznij obsługę</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="canCloseTask" @click="$emit('close-all-tasks')">
                <v-list-item-icon>
                    <v-icon color="success">mdi-progress-check</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Zakończ obsługę</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="canCloseTask" @click="$emit('cancel-task')">
                <v-list-item-icon>
                    <v-icon color="orange">mdi-account-cancel-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Anuluj</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider class="my-1"></v-divider> -->

            <!-- Przypisanie Section -->
            <v-subheader v-if="canCloseTask">Przypisanie</v-subheader>
            <v-list-item v-if="canCloseTask && !isEventForMe" @click="$emit('assign-to-me')">
                <v-list-item-icon>
                    <v-icon color="info">mdi-clipboard-account</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Przejmij obsługę</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="canCloseTask && isEventForMe" @click="$emit('assign-to-other')">
                <v-list-item-icon>
                    <v-icon color="info">mdi-clipboard-account</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Przekaż obsługę</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="canCloseTask && isEventForMe" @click="$emit('release-from-me')">
                <v-list-item-icon>
                    <v-icon color="info">mdi-clipboard-account-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Zrezygnuj z obsługi</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider class="my-1"></v-divider>

            <!-- Akcje Section -->
            <!-- <v-subheader>Akcje</v-subheader>
            <v-list-item v-if="canCloseTask" @click="$emit('send-patrol')">
                <v-list-item-icon>
                    <v-icon>mdi-car-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Wyślij patrol</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="canCloseTask" @click="$emit('found-users')">
                <v-list-item-icon>
                    <v-icon>mdi-account-check-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Osoba w obiekcie</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="canCloseTask" @click="$emit('notify-users')">
                <v-list-item-icon>
                    <v-icon>mdi-account-alert-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Powiadom</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider class="my-1"></v-divider> -->

            <!-- Finansowe Section -->
            <!-- <v-subheader>Finansowe</v-subheader>
            <v-list-item v-if="canChangePayments" @click="$emit('set-payment')">
                <v-list-item-icon>
                    <v-icon>mdi-currency-usd</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Opłata</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider class="my-1"></v-divider>-->

            <!-- Dokumenty Section -->
            <v-subheader>Dokumenty</v-subheader>
            <v-list-item @click="$emit('download')">
                <v-list-item-icon>
                    <v-icon>mdi-cloud-download-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Zapis do pliku</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider class="my-1"></v-divider>

            <!-- Zarządzanie Section -->
            <v-subheader v-if="canEditEvent || canDeleteEvent">Zarządzanie</v-subheader>
            <v-list-item v-if="canEditEvent" @click="$emit('edit-event')">
                <v-list-item-icon>
                    <v-icon>mdi-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Edycja zdarzenia</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="canDeleteEvent" @click="$emit('delete-event')" class="error--text">
                <v-list-item-icon>
                    <v-icon color="error">mdi-delete</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Usuń zdarzenie</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: 'EventActionsMenu',
    props: {
        canCloseTask: {
            type: Boolean,
            default: false
        },
        canOpenTask: {
            type: Boolean,
            default: false
        },
        canEditEvent: {
            type: Boolean,
            default: false
        },
        canDeleteEvent: {
            type: Boolean,
            default: false
        },
        canChangePayments: {
            type: Boolean,
            default: false
        },
        isEventForMe: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
.more-options-btn {
    transition: transform 0.2s ease;
}

.more-options-btn:hover {
    transform: rotate(90deg);
}
</style>
